import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { Layout } from './components/Layout'
import { useStore } from './lib/store'
import { useAuth } from './lib/auth'
import { AuthScreen } from './features/auth/AuthScreen'
import { Onboarding } from './features/onboarding/Onboarding'
import { InboxPage } from './features/inbox/InboxPage'
import { RepliesPage } from './features/replies/RepliesPage'
import { CalendarPage } from './features/calendar/CalendarPage'
import { AgentPage } from './features/agent/AgentPage'
import { AnalyticsPage } from './features/analytics/AnalyticsPage'
import { MediaPage } from './features/media/MediaPage'
import { PlugsPage } from './features/plugs/PlugsPage'
import { SettingsPage } from './features/settings/SettingsPage'
import { McpDocsPage } from './features/docs/McpDocsPage'
import { DataBoot } from './lib/data'
import { workspaceDestination } from './lib/workspace-routing'

function Splash() {
  return (
    <div className="grid min-h-screen place-items-center">
      <Loader2 className="animate-spin text-brand-400" size={28} />
    </div>
  )
}

function WorkspaceEntry() {
  const onboarded = useStore((s) => s.onboarded)
  return <Navigate to={workspaceDestination(onboarded)} replace />
}

function RequireAuth() {
  const { session, loading } = useAuth()
  if (loading) return <Splash />
  if (!session) return <Navigate to="/auth" replace />
  // DataBoot hydrates the store from the worker API for the signed-in user.
  return (
    <DataBoot>
      <Outlet />
    </DataBoot>
  )
}

function AuthRoute() {
  const { session, loading } = useAuth()
  if (loading) return <Splash />
  if (session) return <Navigate to="/" replace />
  return <AuthScreen />
}

export const router = createBrowserRouter([
  { path: '/auth', element: <AuthRoute /> },
  { path: '/docs/mcp', element: <McpDocsPage /> },
  {
    element: <RequireAuth />,
    children: [
      { path: '/', element: <WorkspaceEntry /> },
      { path: '/onboarding', element: <Onboarding /> },
      {
        element: <Layout />,
        children: [
          { path: '/inbox', element: <InboxPage /> },
          { path: '/replies', element: <RepliesPage /> },
          { path: '/calendar', element: <CalendarPage /> },
          { path: '/agent', element: <AgentPage /> },
          { path: '/analytics', element: <AnalyticsPage /> },
          { path: '/media', element: <MediaPage /> },
          { path: '/plugs', element: <PlugsPage /> },
          { path: '/settings', element: <SettingsPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
])
